import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import Nav from '../nav';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

const Guest = ({ content, guestNameList, navIndex, setNavIndex, onChangeMaskVisible, onChangeCurrentVideo }) => {
    const [isShowBottle, setIsShowBottle] = useState(true);
    const swiperRef = useRef(null);
    const bottleRef = useRef(null);

    const swiperChange = (index) => {
        swiperRef.current.slideToLoop(index);

        setNavIndex(index);
    };

    const guestPrev = () => {
        setTimeout(() => {
            setNavIndex(swiperRef.current.realIndex);
        }, 100);
    };

    const guestNext = () => {
        setTimeout(() => {
            setNavIndex(swiperRef.current.realIndex);
        }, 100);
    };

    const openVideo = (data) => {
        onChangeCurrentVideo({
            url: data?.videoPlayUrl || '',
            guid: data?.guid || '',
            duration: data?.duration || '',
        });
        onChangeMaskVisible(true);
    };

    useEffect(() => {
        swiperRef.current.slideToLoop(navIndex);
    }, [navIndex]);

    useEffect(() => {
        const bottleDom = bottleRef.current;
        const bottleHeight = bottleDom.offsetHeight;
        const windowHeight = window.innerHeight;
        let flag = true;

        window.addEventListener('scroll', () => {
            // 判断bottleRef是否完全在可是窗口
            // console.log(bottleDom.getBoundingClientRect().top + bottleHeight <= windowHeight);
            if (bottleDom.getBoundingClientRect().top + bottleHeight <= windowHeight && flag) {
                flag = false;
                setIsShowBottle(false);
                setTimeout(() => {
                    setIsShowBottle(true);
                }, 10);
            }
            if (bottleDom.getBoundingClientRect().top + bottleHeight > windowHeight && !flag) {
                flag = true;
                setIsShowBottle(false);
            }
        });
    }, []);

    return guestNameList.length > 0 ? (
        <div className={styles.guest} id="guest">
            <div className={styles.nav}>
                <Nav content={guestNameList} navIndex={navIndex} setNavIndex={setNavIndex} swiperChange={swiperChange} />
            </div>
            <img className={styles.guestBg} src="https://x0.ifengimg.com/ucms/2025_17/BEB4AAF0CDBA6C250EA5FDDE1A2F12AB676C9193_size1_w1920_h891.png" />
            {guestNameList.length > 1 && (
                <img className={styles.guestPrev} onClick={guestPrev} src="https://x0.ifengimg.com/ucms/2025_17/68469E2034ABAF86C03F481B9028728894ECF885_size0_w73_h133.png" />
            )}
            {guestNameList.length > 1 && (
                <img className={styles.guestNext} onClick={guestNext} src="https://x0.ifengimg.com/ucms/2025_17/C2FB0B08E8A19398223E155F04D78CAE9812B73A_size0_w72_h134.png" />
            )}
            <div className={styles.guestBox}>
                <Swiper
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    navigation={{
                        nextEl: `.${styles.guestNext}`,
                        prevEl: `.${styles.guestPrev}`,
                    }}
                    modules={[Navigation, Pagination]}
                    loop={true}
                    slideClass={styles.slideItem}
                    initialSlide={navIndex}
                    className="mySwiper"
                    onSlideChange={(swiper) => {
                        setIsShowBottle(false);
                        setTimeout(() => {
                            setIsShowBottle(true);
                        }, 300);
                    }}>
                    {guestNameList.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                {/* <div style={{ fontSize: '100px', color: 'red' }}>{index}</div> */}
                                <div className={styles.guestItem}>
                                    <img
                                        className={styles.guestImg}
                                        src={item.userImage}
                                        onClick={() => {
                                            openVideo(content[index][0]);
                                        }}
                                    />
                                    {/* <img
                                        className={styles.guestPlay}
                                        onClick={(item) => {
                                            openVideo(content[index][0]);
                                        }}
                                        src="https://x0.ifengimg.com/ucms/2025_17/8FC1296F8B0C759E4D34C082D22B2741E7FD9A31_size2_w149_h61.png"
                                    /> */}
                                    <div
                                        className={`${styles.guestBottle} ${isShowBottle ? styles.botteleAnimation : ''}`}
                                        ref={bottleRef}
                                        onClick={() => {
                                            openVideo(content[index][0]);
                                        }}>
                                        <img className={styles.guestBottleLeft} src="https://x0.ifengimg.com/ucms/2025_17/63AAF13ADD236F91F75D337F08B8CD0C6857C1A6_size6_w88_h146.png" alt="" />
                                        <img className={styles.guestBottleRight} src="https://x0.ifengimg.com/ucms/2025_17/29D72EF95C0FA43586C52A23B9B6A161DC3CE295_size9_w89_h146.png" alt="" />
                                    </div>
                                    <div className={styles.guestList}>
                                        <img className={styles.guestIcon} src="https://x0.ifengimg.com/ucms/2025_17/10BA150C78B9BF486F239732120932ADF8981A76_size1_w101_h98.png" />
                                        {content?.[index]?.slice(1, 4).map((listItem, listIndex) => {
                                            return (
                                                <div
                                                    key={listItem.base62Id}
                                                    className={styles.guestListItem}
                                                    onClick={() => {
                                                        openVideo(listItem);
                                                    }}>
                                                    <img className={styles.guestListImg} src={formatImage(listItem.thumbnail, 334, 188)} />
                                                    <img className={styles.guestListPlay} src="https://x0.ifengimg.com/ucms/2025_17/23A8DDB9A563D36D0B9BD3DF66007A1EF53223F4_size1_w32_h32.png" />
                                                    <div className={styles.guestListText}>{listItem.title}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    ) : null;
};

Guest.propTypes = {
    content: PropTypes.object,
    guestNameList: PropTypes.array,
    navIndex: PropTypes.number,
    setNavIndex: PropTypes.func,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
};

export default errorBoundary(Guest);
